import React from "react";
import { useSiteData } from "../context/SiteDataContext";

const About: React.FC = () => {
  const { data } = useSiteData();

  return (
    <>
      <div className="page-header">
        <div className="container">
          <h1>Hakkımda</h1>
          <p>Web tasarım ve sesli yazıya çeviri alanında uzmanlaşmış bir profesyonel</p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="about-content">
            <div className="about-image">
              👨‍💻
            </div>
            <div className="about-text">
              <h2>{data.about.title}</h2>
              <p>{data.about.description1}</p>
              <p>{data.about.description2}</p>
              <p>{data.about.description3}</p>

              <div className="about-highlights">
                <div className="highlight-item">
                  <div className="number">{data.about.stat1Number}</div>
                  <div className="label">{data.about.stat1Label}</div>
                </div>
                <div className="highlight-item">
                  <div className="number">{data.about.stat2Number}</div>
                  <div className="label">{data.about.stat2Label}</div>
                </div>
                <div className="highlight-item">
                  <div className="number">{data.about.stat3Number}</div>
                  <div className="label">{data.about.stat3Label}</div>
                </div>
                <div className="highlight-item">
                  <div className="number">{data.about.stat4Number}</div>
                  <div className="label">{data.about.stat4Label}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Yetenekler */}
      <section className="section section-light">
        <div className="container">
          <div className="section-header">
            <h2>Uzmanlık Alanlarım</h2>
          </div>
          <div className="services-grid">
            {data.about.skills.map((skill, idx) => (
              <div key={idx} className="service-card">
                <div className="service-icon">{skill.icon}</div>
                <h3>{skill.title}</h3>
                <p>{skill.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
